<template>
  <div class="orderSuccess">
    <section class="main_content">
      <div
        class="order_confirmation success">
        <img src="../assets/images/check-mark-success.gif" alt="payment-success" />
        <span class="congratsText">{{$t('congrats')}}</span>
        <span class="got_order">{{$t('taskUploadedSuccessfully')}}</span>
      </div>
    </section>
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>
<script>
export default {
  name: "UploadSuccess",
  data() {
    return {
      loading: false,
    };
  },
  methods: {
      goToHome(){
        setTimeout(() => {
              // this.$router.replace(
              //   "/order-history?orderId=" + this.$route.params.orderId
              // );
              this.$router.replace("/");
            }, 2000);
      }
  },
  mounted() {
    this.goToHome()
  }
};
</script>
<style lang="css" scoped>
.order_confirmation {
	 text-align: center;
}
 .order_confirmation.success img {
	 width: 50%;
	 display: block;
	 margin: 40px auto;
}
 .order_confirmation .congratsText {
	 font-size: 1.5em;
	 margin-bottom: 0.75em;
	 font-weight: 700;
	 color: #138808;
	 display: block;
}
 .order_confirmation .got_order {
	 font-size: 1.05em;
	 margin: 5px 0;
	 font-weight: 700;
	 display: block;
}
 
</style>